$(document).ready(function () {
  $('#summernote').summernote({
    lang: 'uk-UA',
    height: 200,
    toolbar: [
      // [groupName, [list of button]]
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['font', ['strikethrough', 'superscript', 'subscript']],
      ['fontsize', ['fontsize']],
      ['color', ['color']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['height', ['height']],
      ['link', ['linkDialogShow', 'unlink']]
    ]
  });
  $('#summernote-admin').summernote({
    lang: 'uk-UA',
    height: 200,
    toolbar: [
      // [groupName, [list of button]]
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['font', ['strikethrough', 'superscript', 'subscript']],
      ['fontsize', ['fontsize']],
      ['color', ['color']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['height', ['height']],
      ['link', ['linkDialogShow', 'unlink']],
      ['insert', ['picture']]
    ]
  });
});

